import { render, staticRenderFns } from "./ArticleFilter.vue?vue&type=template&id=24204a46&scoped=true&"
import script from "./ArticleFilter.vue?vue&type=script&lang=js&"
export * from "./ArticleFilter.vue?vue&type=script&lang=js&"
import style0 from "./ArticleFilter.vue?vue&type=style&index=0&id=24204a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24204a46",
  null
  
)

export default component.exports